import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

let globalCloseMenu = null; // Global reference to track the open menu

const RightContextMenuWrapper = ({
  isActive = false,
  children,
  menuItems = [
    { label: "Option 1", icon: <Edit />, onClick: () => {} },
    { label: "Option 2", icon: <Delete />, onClick: () => {} },
  ],
  rowData,
  hideItems = [],
  onRightClick = () => {},
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const menuRef = useRef(null);

  const closeMenu = () => {
    setMenuVisible(false);
  };

  const handleContextMenu = (event) => {
    event.preventDefault();

    // If clicking again on the same element, do not toggle to parent menu
    if (menuVisible) {
      event.stopPropagation(); // Stop event from reaching parent
      closeMenu();
      return;
    }

    // Close any previously open menu before opening a new one
    if (globalCloseMenu) globalCloseMenu();

    setPosition({ x: event.clientX, y: event.clientY });
    setMenuVisible(true);

    // Update the global reference to track the open menu
    globalCloseMenu = closeMenu;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
        if (globalCloseMenu === closeMenu) {
          globalCloseMenu = null;
        }
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleChildContextMenu = (event) => {
    onRightClick(rowData);
    event.stopPropagation(); // Prevent bubbling up to parent
    handleContextMenu(event);
  };

  return (
    <>
      {isActive ? (
        <>
          {React.cloneElement(children, { onContextMenu: handleChildContextMenu })}
          {createPortal(
            <Menu
              ref={menuRef}
              open={menuVisible}
              onClose={closeMenu}
              anchorReference="anchorPosition"
              anchorPosition={{ top: position.y, left: position.x }}
              // slotProps={{
              //   root: {
              //     hideBackdrop: true,
              //     style: {
              //       // zIndex: 100000000000,
              //       pointerEvents: "none",
              //     }
              //   },
              //   paper: {
              //     // zIndex: 100000000000,
              //     pointerEvents: "none",
              //   },

              // }}
            >
              {menuItems
                ?.filter((data) => !hideItems.includes(data?.label?.toLowerCase()))
                .map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (item.onClick) item.onClick(rowData);
                      closeMenu();
                    }}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                        color: "#1976d2",
                      },
                    }}
                  >
                    {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                    <ListItemText primary={item.label} />
                  </MenuItem>
                ))}
            </Menu>,
            document.body
          )}
        </>
      ) : (
        children
      )}
    </>
  );
};

export default RightContextMenuWrapper;
